import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Toast() {
  return (
    <div>
      <ToastContainer />
    </div>
  );
}

export default React.memo(Toast);
